import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

export const DEFAULT_VISIBLE_PREVIEW_ROWS = 5;
export const DEFAULT_SKELETONS_ROWS = 4;
export const DEFAULT_VALID_QUERY_LENGTH = 3;

export const ACTION_CELL_WIDTH_WITH_BADGES = '136px';

export const simpleTablePropTypes = {
  ...WithLoadingPropTypes,
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  customStyles: PropTypes.object,
  dataTestId: PropTypes.string,
  isCustomDataDefinition: PropTypes.bool,
  isHideTableWhenEmpty: PropTypes.bool,
  isPreview: PropTypes.bool,
  isSortDisabled: PropTypes.bool,
  order: PropTypes.object,
  previewRows: PropTypes.number,
  skeletonRows: PropTypes.number,
  title: PropTypes.string,
  pendingChangesTextSelector: PropTypes.string,
  withAddButton: PropTypes.bool,
  isAddButtonDisabled: PropTypes.bool,
  withDivider: PropTypes.bool,
  withInternalBorders: PropTypes.bool,
  onAddClick: PropTypes.func,
  onRequestSort: PropTypes.func,
  isStickyHeader: PropTypes.bool,
  onRowClick: PropTypes.func,
  isSearchOnChange: PropTypes.bool,
  validQueryLength: PropTypes.number,
  customSearchControls: PropTypes.node,
  fetchTableData: PropTypes.func,
  withSelectableRows: PropTypes.bool,
  noAvailableMessageText: PropTypes.string,
  noAvailableMessageIcon: PropTypes.func,
  rowTestId: PropTypes.string,
  getRowProps: PropTypes.func,
  containerRef: PropTypes.object,
  searchDataTestId: PropTypes.string,
  searchAriaLabel: PropTypes.string,
  // Column filter props
  columnFilters: PropTypes.object,
  onColumnFiltersChange: PropTypes.func,
  // Droppable props
  isDroppable: PropTypes.bool,
  onDragEnd: PropTypes.func,
  droppableId: PropTypes.string,
  tooltipEnterDelay: PropTypes.number,
  // (row, fieldNames) => author rows of a modified cell's pending change, shown as author dots.
  getCellPendingChangeAuthors: PropTypes.func,
};

export const IS_NEAR_BOTTOM = 100;
